// containers/TotalSalesMonth.jsx
import React, { useEffect, useState } from "react";
import AverageTotalSales30DaysDisplay from "../../components/VentasDatos/AverageTotalSales30DaysDisplay";
import { getUser } from "../../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function AverageTotalSales15Days() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    const fetchTotal = async () => {
      const user = getUser();
      try {
        const res = await fetch(`${URL}/api/sales/datos/summary/average-sales-total-30-days/`, {
          headers: {
            "x-empresa-id": user?.empresa_id,
          },
        });
        if (!res.ok) throw new Error("Error al obtener el promedio del total de las ventas");
        const data = await res.json();
        setTotal(data.average_sales_total);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTotal();
  }, []);

  return <AverageTotalSales30DaysDisplay total={total} />;
}
